<template>
    <section class="profile">
        <header class="profile__header">
            <h1>Профиль</h1>
            <p>Учётная запись и данные регистрации</p>
        </header>

        <section class="profile__card">
            <h2 class="profile__card-title">Логин</h2>
            <dl class="profile__fields">
                <div class="profile__field">
                    <dt>Email</dt>
                    <dd>{{ email }}</dd>
                </div>
            </dl>
            <a href="/profile/password" class="profile__link">Сменить пароль</a>
        </section>

        <section class="profile__card">
            <h2 class="profile__card-title">Баланс</h2>
            <div class="profile__balance">
                <span class="profile__balance-value">—</span>
                <span class="profile__balance-hint">Скоро</span>
            </div>
        </section>

        <section class="profile__card">
            <h2 class="profile__card-title">Данные регистрации</h2>

            <p v-if="!msb" class="profile__empty">Данные регистрации отсутствуют</p>

            <dl v-else class="profile__fields">
                <div class="profile__field">
                    <dt>Тип организации</dt>
                    <dd>{{ msb.type_label }}</dd>
                </div>
                <div class="profile__field">
                    <dt>ФИО кто проводит регистрацию</dt>
                    <dd>{{ display(msb.registrant_full_name) }}</dd>
                </div>

                <template v-if="msb.type === 'ip'">
                    <div class="profile__field">
                        <dt>Официальное название ИП</dt>
                        <dd>{{ display(msb.ip_official_name) }}</dd>
                    </div>
                    <div class="profile__field">
                        <dt>ИИН</dt>
                        <dd>{{ display(msb.iin) }}</dd>
                    </div>
                    <div class="profile__field">
                        <dt>Адрес места жительства</dt>
                        <dd>{{ display(msb.residence_address) }}</dd>
                    </div>
                    <div class="profile__field">
                        <dt>Адрес места ведения деятельности отличается</dt>
                        <dd>{{ yesNo(msb.activity_address_differs) }}</dd>
                    </div>
                    <div v-if="msb.activity_address_differs" class="profile__field">
                        <dt>Адрес места ведения деятельности</dt>
                        <dd>{{ display(msb.activity_address) }}</dd>
                    </div>
                    <div class="profile__field">
                        <dt>Название ИП (если не совпадает с фамилией)</dt>
                        <dd>{{ display(msb.ip_trade_name) }}</dd>
                    </div>
                </template>

                <template v-else>
                    <div class="profile__field">
                        <dt>Название компании</dt>
                        <dd>{{ display(msb.company_name) }}</dd>
                    </div>
                    <div class="profile__field">
                        <dt>БИН</dt>
                        <dd>{{ display(msb.bin) }}</dd>
                    </div>
                    <div class="profile__field">
                        <dt>Адрес места нахождения</dt>
                        <dd>{{ display(msb.location_address) }}</dd>
                    </div>
                    <div class="profile__field">
                        <dt>Юридический адрес отличается от фактического</dt>
                        <dd>{{ yesNo(msb.legal_address_differs) }}</dd>
                    </div>
                    <div v-if="msb.legal_address_differs" class="profile__field">
                        <dt>Юридический адрес</dt>
                        <dd>{{ display(msb.legal_address) }}</dd>
                    </div>
                    <div class="profile__field">
                        <dt>Должность</dt>
                        <dd>{{ display(msb.position) }}</dd>
                    </div>
                </template>

                <div class="profile__field">
                    <dt>Код ОКЭД (основной вид деятельности)</dt>
                    <dd>{{ display(msb.oked_primary) }}</dd>
                </div>
                <div v-if="msb.type === 'too'" class="profile__field">
                    <dt>Дополнительные коды ОКЭД</dt>
                    <dd>{{ okedAdditional }}</dd>
                </div>
                <div class="profile__field">
                    <dt>Телефон</dt>
                    <dd>{{ display(msb.phone) }}</dd>
                </div>
                <div v-if="msb.offer_accepted_at" class="profile__field">
                    <dt>Оферта принята</dt>
                    <dd>{{ formatDate(msb.offer_accepted_at) }}</dd>
                </div>
            </dl>
        </section>
    </section>
</template>

<script>
import { formatInRtbTZ } from '../../utils/timezones';

export default {
    name: 'UserProfile',
    props: {
        userData: {
            type: Object,
            default: () => ({}),
        },
        msb: {
            type: Object,
            default: null,
        },
    },
    computed: {
        email() {
            return this.userData?.email || '—';
        },
        okedAdditional() {
            const list = this.msb?.oked_additional;
            if (!Array.isArray(list) || list.length === 0) {
                return '—';
            }
            return list.join(', ');
        },
    },
    methods: {
        display(value) {
            if (value === null || value === undefined || value === '') {
                return '—';
            }
            return value;
        },
        yesNo(value) {
            return value ? 'Да' : 'Нет';
        },
        formatDate(iso) {
            return formatInRtbTZ(iso);
        },
    },
};
</script>
